export default __webpack_public_path__ + "static/media/blank.882cfe2f.svg";